import { render } from "./PostTransplantPancreasSectionDetails.vue?vue&type=template&id=443f1a9b&scoped=true"
import script from "./PostTransplantPancreasSectionDetails.vue?vue&type=script&lang=js"
export * from "./PostTransplantPancreasSectionDetails.vue?vue&type=script&lang=js"

import "./PostTransplantPancreasSectionDetails.vue?vue&type=style&index=0&id=443f1a9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443f1a9b"],['__file',"src/components/PostTransplantPancreasSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "443f1a9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('443f1a9b', __exports__)) {
    api.reload('443f1a9b', __exports__)
  }
  
  module.hot.accept("./PostTransplantPancreasSectionDetails.vue?vue&type=template&id=443f1a9b&scoped=true", () => {
    api.rerender('443f1a9b', render)
  })

}


export default __exports__